import React from "react";
import { Card, Grid, Typography, Box } from "@material-ui/core";
import ProgressBar from "@icarius-pages/performanceEvaluationsCalibration/components/calibrationForm/steps/stepFive/progressBar";
import { formatNumberOrReturnUndefined } from "@icarius-utils/format";
import { getLocalizedString } from "@icarius-localization/strings";

const Header = (props) => {

    const {
        evaluatedName,
        color,
        summaryData,
        process,
        level,
    } = props;

    const types = {
        DES: getLocalizedString("descendingEvaluation"),
        ASC: getLocalizedString("ascendingEvaluation"),
        AUT: getLocalizedString("selfAssessment"),
        PAR: getLocalizedString("peerEvaluation"),
    }

    return (
        <Grid container item xs={12}>
            <Card style={{ padding: 20, marginTop: 20, width: '95%' }}>
                <Grid container item xs={12} alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h4" className="whiteText" style={{ fontWeight: 700, width: "100%" }}>
                            {process.processName}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h6" style={{ fontWeight: 700, width: "100%", color: color }}>
                            {evaluatedName}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={12} md={6} xl={8}>
                        <Typography className="whiteText" style={{ width: "100%" }}>
                            {`${getLocalizedString("evaluationDateFrom")}: ${process.periodFromDate}`}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={4} xl={4}>
                        <Typography className="whiteText" style={{ fontWeight: 700, width: "100%" }}>
                            {summaryData.status}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={12} md={6} xl={8}>
                        <Typography className="whiteText" style={{ width: "100%" }}>
                            {`${getLocalizedString("evaluationDateTo")}: ${process.periodEndDate}`}
                        </Typography>
                    </Grid>
                    {
                        level !== "C" && <Grid item xs={12} md={6} xl={4}>
                            <Typography className="whiteText" style={{ fontWeight: 700, width: "100%", fontStyle: "italic" }}>
                                {summaryData.revision}
                            </Typography>
                        </Grid>
                    }
                </Grid>
                <Grid container item xs={12} style={{ marginTop: 10 }}>
                    <Grid container item xs={12} md={6} xl={8} justify="space-between" alignContent="space-between">
                        {
                            summaryData.evaluations.map((evaluation) => (
                                <Grid container item xs={12} key={evaluation.type} spacing={2}>
                                    <Grid item md={3} xs={3} className="whiteText">
                                        {types[evaluation.type]}
                                    </Grid>
                                    <Grid item xs={3} md={3} xl={1} style={evaluation.status === "Realizada" ? { color: "#00c700" } : { color: "red" }} >
                                        {evaluation.status}
                                    </Grid>
                                    <Grid item xs={3} md={3} xl={1} className="whiteText">
                                        {evaluation.resultType}
                                    </Grid>
                                    <Grid item xs={3} md={3} xl={1} className="whiteText" style={{ fontWeight: 700 }}>
                                        {`${evaluation.weightPercent}%`}
                                    </Grid>
                                </Grid>
                            ))
                        }
                    </Grid>
                    <Grid container item xs={12} md={6} xl={4}>
                        {/* Nota final */}
                        <Grid container item xs={12} alignItems="center" spacing={1}>
                            <Grid item xs={5}>
                                <Typography className="whiteText" style={{ fontWeight: 700 }}>
                                    {summaryData.isPartialNote
                                        ? getLocalizedString("partialNotePerformance")
                                        : getLocalizedString("finalNotePerformance")}
                                </Typography>
                            </Grid>

                            <Grid item xs={3}>
                                <Typography
                                    sx={{
                                        color: "black",
                                        fontSize: 16,
                                        textAlign: "center",
                                        fontWeight: 400,
                                    }}
                                >
                                    {formatNumberOrReturnUndefined(summaryData.note, 1, 1)}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Box
                                    sx={{
                                        backgroundColor: summaryData.noteColor,
                                        textAlign: "center",
                                        color: "black",
                                        height: 24,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {summaryData.noteString}
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid container item xs={12} sx={{ height: 10 }} />

                        {/* Ranking */}
                        <Grid container item xs={12} alignItems="center" spacing={1}>
                            <Grid item xs={5}>
                                <Typography
                                    className="whiteText"
                                    sx={{
                                        color: "black",
                                        fontWeight: 400,
                                        fontSize: 16,
                                    }}
                                >
                                    {`${getLocalizedString("maximumNote")}: ${formatNumberOrReturnUndefined(
                                        summaryData.maxNote,
                                        1,
                                        1
                                    )}`}
                                </Typography>
                            </Grid>

                            <Grid item xs={3}>
                                <Typography
                                    sx={{
                                        color: "black",
                                        fontSize: 16,
                                        textAlign: "center",
                                        fontWeight: 400,
                                    }}
                                >
                                    {getLocalizedString("ranking")}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <ProgressBar value={summaryData.ranking} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </Grid>
    )
}

export default Header;